import { GearSix, X } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { IntegrationSettings } from "common/types";

import { INTEGRATIONS_MAP } from "../constants";

import type { ReactNode } from "react";

export default function SettingsContainer({
  integrationKey,
  children,
  isOpen,
  setIsOpen,
}: {
  integrationKey: keyof IntegrationSettings;
  children: ReactNode;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { title } = INTEGRATIONS_MAP[integrationKey];

  const Component = isDesktop ? Popover : Drawer;
  const Trigger = isDesktop ? PopoverTrigger : DrawerTrigger;
  const Content = isDesktop ? PopoverContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button variant="secondary-black" intent="iconOnly" size="sm">
          <GearSix />
        </Button>
      </Trigger>
      <Content className="lg:w-96" align="start">
        {isDesktop ? (
          <div className="p-4 flex items-center border-b border-b-black-200 justify-between">
            <h3 className="text-md-bold">{title} settings</h3>
            <PopoverClose>
              <X className="text-black-500 size-5" />
            </PopoverClose>
          </div>
        ) : (
          <DrawerTitle className="mb-8">{title} settings</DrawerTitle>
        )}
        {children}
      </Content>
    </Component>
  );
}
